var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.31,169.68c-83.14-50.79-171.46,15.61-157.37,90.23,14.44,72.88,134.73,150.29,214.32,105.9,75.24-40.94,92.83-180,17.27-198.6C337.51,163.2,310.63,178.83,287.31,169.68Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.31,169.68c-83.14-50.79-171.46,15.61-157.37,90.23,14.44,72.88,134.73,150.29,214.32,105.9,75.24-40.94,92.83-180,17.27-198.6C337.51,163.2,310.63,178.83,287.31,169.68Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-19",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.66,412.68H262.11L243.43,353.9a27.15,27.15,0,0,0-26-19H203a27.14,27.14,0,0,0-26,19l-18.69,58.78H137.81l19-59.9a30.83,30.83,0,0,1,29.5-21.59h47.78a30.86,30.86,0,0,1,29.51,21.59Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.66,412.68H262.11L243.43,353.9a27.15,27.15,0,0,0-26-19H203a27.14,27.14,0,0,0-26,19l-18.69,58.78H137.81l19-59.9a30.83,30.83,0,0,1,29.5-21.59h47.78a30.86,30.86,0,0,1,29.51,21.59Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.66,412.68h-3.88L260.1,353.9a27.15,27.15,0,0,0-26-19H203a27.14,27.14,0,0,0-26,19l-18.69,58.78h-3.87l19-59.9A30.83,30.83,0,0,1,203,331.19h31.11a30.86,30.86,0,0,1,29.51,21.59Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.76,251a6.16,6.16,0,0,0-5.19-2.84H286.63a6.17,6.17,0,0,0-5.6,3.58L232.79,356.34H144a6.17,6.17,0,1,0,0,12.34h175.7a6.18,6.18,0,0,0,5.6-3.58L375.17,257A6.16,6.16,0,0,0,374.76,251Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.76,251a6.16,6.16,0,0,0-5.19-2.84H286.63a6.17,6.17,0,0,0-5.6,3.58L232.79,356.34H144a6.17,6.17,0,1,0,0,12.34h175.7a6.18,6.18,0,0,0,5.6-3.58L375.17,257A6.16,6.16,0,0,0,374.76,251Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.68,368.68H226.91a6.17,6.17,0,0,1,0-12.34h88.82L364,251.78a6.17,6.17,0,0,1,11.2,5.17L325.28,365.1A6.18,6.18,0,0,1,319.68,368.68Z",
    style: {
      fill: "#3AC99E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.19,264.66l-1.29.49-1.19.42c-.79.28-1.59.51-2.38.76-1.59.48-3.19.9-4.82,1.27a61.06,61.06,0,0,1-10.12,1.51,36.91,36.91,0,0,1-11.18-.86l-.74-.18-.37-.1-.19-.05a1.43,1.43,0,0,1-.27-.08,10.58,10.58,0,0,1-3.06-1.53,10.36,10.36,0,0,1-3.59-12,4.75,4.75,0,0,1,.19-.46l.14-.29.28-.59.55-1.17a68.79,68.79,0,0,1,5-8.56c1.8-2.69,3.76-5.21,5.76-7.66s4.1-4.79,6.28-7.05,4.38-4.42,6.82-6.53l5.43,4.86c-3.22,5-6.52,10-9.48,15.1-.76,1.26-1.47,2.53-2.2,3.8s-1.4,2.54-2,3.82a73.31,73.31,0,0,0-3.46,7.58l-.34.93-.17.46-.08.23c0,.06-.09.22,0,.08a3.25,3.25,0,0,0,.14-2.05,3.37,3.37,0,0,0-1.21-1.82,3.63,3.63,0,0,0-1-.54c-.07,0,0,0,0,0h.09l.19,0,.37.06a27.42,27.42,0,0,0,7,0,62.06,62.06,0,0,0,7.88-1.42c1.34-.3,2.67-.69,4-1l2-.6,1-.3.86-.29Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.71,255.38c-3.26-6.2-13.5-9.28-32.63-3.51l.28,21S309.17,271.46,300.71,255.38Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.37,258.64c-5.69-1.38-13,2.34-20.05,14.21,3.78-.22,17.82-1.26,26.17-5.48C295.85,263.18,294.32,259.84,289.37,258.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.44 411.29 162.28 407.34 167.95 382.07 178.11 386.01 172.44 411.29",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,402.8l9.93.18a.9.9,0,0,1,.85.8l1.59,10.32a1.73,1.73,0,0,1-1.62,2c-4.08-.14-5.95-.45-11.09-.53-3.17,0-12.72.19-17.09.12s-4.72-4.87-2.91-5.28c8.1-1.83,15.94-4.44,18.62-7A2.49,2.49,0,0,1,164,402.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.11 386.02 167.95 382.07 165.03 395.1 175.5 397.68 178.11 386.02",
    style: {
      opacity: 0.2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.21,323.2s-22.49-.12-55.48,6.55c-22.86,4.62-34,58.27-34,58.27l16.33,5.83s11-36.46,21.5-44.4c54.78-.27,82.14,16,88.93-19.93C280.46,325.87,252.21,323.2,252.21,323.2Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "159.38 391.09 181.36 395.68 183.11 388.43 160.19 383.17 159.38 391.09",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.79,223.08l5.14-5.65,9,6s-5.55,7-11.94,4.82Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.74 213.18 289.73 218.93 285.95 223.39 276.93 217.43 286.74 213.18",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.22,233.48l-9.09-7.33a.85.85,0,0,1-.08-1.26l15.71-16.48a1,1,0,0,1,1.37-.09l9.09,7.33a.84.84,0,0,1,.08,1.26l-15.71,16.48A1,1,0,0,1,287.22,233.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.83,332.12s16.6-24.44,24.67-63.83a15.49,15.49,0,0,0-14.45-18.51c-8-.42-16.44-.53-23.3-.5a15.46,15.46,0,0,0-14.81,11.21,349.92,349.92,0,0,1-24.73,62.71Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.22,267.69a1.54,1.54,0,0,0-2.4-.35l-8.72,7.07L284.31,267a1.5,1.5,0,0,0-2.27-.76,2.33,2.33,0,0,0-1,2.71l3,8-9.18,7.45a2.29,2.29,0,0,0-.62,2.79,1.47,1.47,0,0,0,1.17.77,1.78,1.78,0,0,0,1.22-.42l8.72-7.07,2.79,7.46a1.49,1.49,0,0,0,1.3,1,1.65,1.65,0,0,0,1-.25,2.34,2.34,0,0,0,1-2.71l-3-8,9.18-7.45A2.29,2.29,0,0,0,298.22,267.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.73,263.61c-5.58-7.79-10.58-8.89-12-8.45-12.93,4.07.94,39.67,3.09,43.65a214.68,214.68,0,0,0,8.65-30.52A15.46,15.46,0,0,0,329.73,263.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,253.44a1.85,1.85,0,0,1-1.55-2.86c.24-.37,6.06-9.14,14.85-7.6a1.85,1.85,0,1,1-.64,3.65c-6.35-1.12-11.07,5.91-11.11,6A1.86,1.86,0,0,1,288,253.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.2,224.7c-2.6,7.07-5.93,19.87-1.9,25a25.25,25.25,0,0,1-18,6.13c-8.3-.28-6.61-3.6-3.9-6.54,8.08-1.37,8.91-8.16,8.53-13.82Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.8,251.68c0,3.44,2.43,6.22,5.43,6.22s5.42-2.78,5.42-6.22-2.43-6.22-5.42-6.22S278.8,248.25,278.8,251.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.8,251.68c0,3.44,2.43,6.22,5.43,6.22s5.42-2.78,5.42-6.22-2.43-6.22-5.42-6.22S278.8,248.25,278.8,251.68Z",
    style: {
      fill: "#3AC99E",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.45,251.68a7.1,7.1,0,1,0,7.09-7.09A7.1,7.1,0,0,0,279.45,251.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,229.09l-9,6.36a22.25,22.25,0,0,1,0,4c3-.24,7.68-3.31,8.55-6.48A11.15,11.15,0,0,0,309,229.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.09,214.87c-2.32,9.37-3.2,15-8.91,19.17a12.47,12.47,0,0,1-20.11-9.28c-.48-8.76,3.39-22.63,13.42-25.16C312.37,197.11,320.41,205.49,318.09,214.87Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,207.71c-3.47-3.81-20,2.33-21.87-6.1s7.56-10.38,11.26-6.42c2.1,2.25,7.37-2.19,9.71,1.23,3.91,5.71,9.6,2.62,11.24,8C325.49,208.87,318.38,212.73,313.79,207.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.89,208.72s3.36-2.26,6.39,2.75A19.87,19.87,0,0,0,320.89,208.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.27,207.42l-4.11-1.69c-5.76,2.1-5.61,6.21-5.61,10.07a10.78,10.78,0,0,1-3.08,7.59l5.35,1.71S332.78,217.09,321.27,207.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.63,226.43a8.72,8.72,0,0,1-6.18,1.65c-2.88-.36-3.09-3.12-1.25-5.19,1.64-1.86,5.13-3.92,7.52-2.51S321.8,224.81,319.63,226.43Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.14,215.18c-.14.77-.67,1.34-1.18,1.28s-.8-.75-.66-1.52.67-1.34,1.17-1.27S302.28,214.41,302.14,215.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.83,214.17c-.14.77-.67,1.34-1.18,1.27s-.8-.74-.66-1.51.67-1.34,1.18-1.27S293,213.4,292.83,214.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.1,215s-2.58,4.21-4.92,6.1c1.14,1.45,3.58,1.18,3.58,1.18Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.06,226.15a6.94,6.94,0,0,0,4.85-1.94.22.22,0,1,0-.33-.3,6.62,6.62,0,0,1-5.46,1.72.25.25,0,0,0-.27.2.21.21,0,0,0,.19.25A7.39,7.39,0,0,0,298.06,226.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,213a.53.53,0,0,0,.23-.06.47.47,0,0,0,.2-.62,4.32,4.32,0,0,0-3.37-2.36.48.48,0,0,0-.51.43.43.43,0,0,0,.41.48h0a3.43,3.43,0,0,1,2.64,1.9A.46.46,0,0,0,306,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.28,210.8a.5.5,0,0,0,.42-.13,3.81,3.81,0,0,1,3.2-1.15.49.49,0,0,0,.55-.37.43.43,0,0,0-.33-.53,4.84,4.84,0,0,0-4.05,1.41.44.44,0,0,0,0,.64A.41.41,0,0,0,291.28,210.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.66 413.38 125.93 404.11 145.69 387.35 151.41 396.62 131.66 413.38",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.29,400.9l9.18,7a.85.85,0,0,1,.14,1.1l-5.12,9.05a1.71,1.71,0,0,1-2.42.73c-2.9-2.32-4.89-4.18-8.61-7-2.28-1.75-9.42-6.76-12.58-9.19s-.49-6.42,1.08-5.77c7.05,2.95,13.15,4.24,16.65,3.69A2.16,2.16,0,0,1,129.29,400.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.41 396.63 145.68 387.36 135.5 396 142.3 404.36 151.41 396.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.32,325.59s-34,6-66,16.34c-22.19,7.17-60.82,48.19-60.82,48.19L149,404.61s47.79-34.46,57.36-43.55c54.4-6.46,95.8,7.55,98.48-28.94C295.42,329.51,266.32,325.59,266.32,325.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.93 390.54 149.7 407.44 155.47 402.71 140.34 384.7 134.93 390.54",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.35,263.59a218.77,218.77,0,0,1,3.94,22.14c.46,3.75.83,7.54,1,11.47.07,2,.09,4,0,6.09-.06,1.07-.15,2.16-.33,3.34a22.45,22.45,0,0,1-.92,4,13.31,13.31,0,0,1-1.25,2.63,15.9,15.9,0,0,1-1.38,1.83,19.72,19.72,0,0,1-3,2.76,31.09,31.09,0,0,1-5.92,3.43A60.51,60.51,0,0,1,311,324.92a111.4,111.4,0,0,1-22.63,2.49l-.78-7.24a200.18,200.18,0,0,0,20.3-6,58.62,58.62,0,0,0,9-4,18.39,18.39,0,0,0,3.33-2.4,6.64,6.64,0,0,0,1-1.07,2.77,2.77,0,0,0,.22-.39c-.13.18-.15.23-.14.14a13.56,13.56,0,0,0,.16-1.4c0-.64.05-1.37,0-2.13,0-1.52-.11-3.17-.27-4.85-.32-3.35-.8-6.82-1.35-10.3-1.11-6.95-2.46-14.07-3.85-21Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.71,250.41c2,.53,11.07,1.9,17.52,24.07l-21.8,8.5S299.34,245.23,318.71,250.41Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.23,255.08a7.1,7.1,0,1,1-7.1-7.09A7.09,7.09,0,0,1,311.23,255.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.76,258.92a1.85,1.85,0,0,1-.6-3.6c.12,0,8.06-2.85,8.55-9.28a1.85,1.85,0,1,1,3.69.28c-.68,8.89-10.62,12.36-11,12.51A2.08,2.08,0,0,1,303.76,258.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,255.08c0,3.43-2.43,6.22-5.43,6.22s-5.42-2.79-5.42-6.22,2.42-6.22,5.42-6.22S311.88,251.64,311.88,255.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,255.08c0,3.43-2.43,6.22-5.43,6.22s-5.42-2.79-5.42-6.22,2.42-6.22,5.42-6.22S311.88,251.64,311.88,255.08Z",
    style: {
      fill: "#3AC99E",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,319.84l-8.46,1.21,4,10.24s9.24-2.36,9.2-7l-2-3.21A2.81,2.81,0,0,0,289,319.84Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.56 326.18 276.85 334.51 284.56 331.29 280.54 321.05 271.56 326.18",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.32,328.75H296.48a2.45,2.45,0,0,1,2.43,2.44h-111A2.45,2.45,0,0,1,190.32,328.75Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.32,328.75H296.48a2.45,2.45,0,0,1,2.43,2.44h-111A2.45,2.45,0,0,1,190.32,328.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5,328.75h31a2.45,2.45,0,0,1,2.43,2.44H263.06A2.45,2.45,0,0,1,265.5,328.75Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.52,274.48h74.31a5.75,5.75,0,0,1,5.29,4.31l10.34,45.65a3.35,3.35,0,0,1-3.34,4.31H189.81a5.75,5.75,0,0,1-5.3-4.31l-10.33-45.65A3.34,3.34,0,0,1,177.52,274.48Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.52,274.48h74.31a5.75,5.75,0,0,1,5.29,4.31l10.34,45.65a3.35,3.35,0,0,1-3.34,4.31H189.81a5.75,5.75,0,0,1-5.3-4.31l-10.33-45.65A3.34,3.34,0,0,1,177.52,274.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.37,326.7,254.2,277.35a1,1,0,0,1,1.71-.88,5.4,5.4,0,0,1,1.22,2.33l10.32,45.64a3.65,3.65,0,0,1-.24,2.51A1,1,0,0,1,265.37,326.7Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.92,412.68H348.37L329.69,353.9a27.15,27.15,0,0,0-26-19H289.27a27.15,27.15,0,0,0-26,19l-18.68,58.78H224.07l19-59.9a30.82,30.82,0,0,1,29.49-21.59h47.78a30.85,30.85,0,0,1,29.51,21.59Z",
    style: {
      fill: "#3AC99E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.92,412.68H348.37L329.69,353.9a27.15,27.15,0,0,0-26-19H289.27a27.15,27.15,0,0,0-26,19l-18.68,58.78H224.07l19-59.9a30.82,30.82,0,0,1,29.49-21.59h47.78a30.85,30.85,0,0,1,29.51,21.59Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.92,412.68H365L346.36,353.9a27.15,27.15,0,0,0-26-19H289.27a27.15,27.15,0,0,0-26,19l-18.68,58.78h-3.88l19-59.9a30.82,30.82,0,0,1,29.49-21.59h31.11a30.85,30.85,0,0,1,29.51,21.59Z",
    style: {
      fill: "#3AC99E"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUs.33d2730ddf412be7537593c4a52936ff.svg";
export { ForwardRef as ReactComponent };